export const ROUTE_FEEDS = 'ROUTE_FEEDS'
